import React from 'react';
export function Ellipse() {
  return <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <ellipse cx="10.999981" cy="10.999981" rx="10.0476" ry="10.0476" fill="transparent" stroke="currentColor" strokeWidth="1.90476" />
    </svg>;
}